const NonnegativeInputField = ({ valuee, title, label, onChange }) => {
  const handleInputChange = (event) => {
    const { value } = event.target;

    // Allow clearing the field
    if (value === "") {
      onChange("");
      return;
    }

    const parsedValue = parseInt(value, 10);

    if (!isNaN(parsedValue) && parsedValue >= 0) {
      onChange(parsedValue.toString());
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "-" || event.key === "e") {
      event.preventDefault();
    }
  };

  return (
    <div>
      <div className=" block my-5 text-[18px] text-[#1E222B] font-[500]">
        {title}
      </div>
      <label className=" block my-3 text-[14px] font-[400] text-back-[#1E222B]">
        {label}
      </label>
      <input
        type="number"
        className=" w-full border p-3 rounded-md"
        value={valuee}
        onChange={handleInputChange}
        required
        onKeyDown={handleKeyDown}
        min="0"
      />
    </div>
  );
};

export default NonnegativeInputField;
